import { addMethod, string, StringSchema } from "yup";

const latRegex = /^-?([0-8]?[0-9]|90)(\.[0-9]+)?$/g;
const lngRegex = /^-?([0-9]{1,2}|1[0-7][0-9]|180)(\.[0-9]+)?$/g;

// eslint-disable-next-line func-names
addMethod<StringSchema>(string, "validLatitude", function () {
  return this.test("valid latitude", (val : string|undefined) => !val || val!.match(latRegex) != null);
});

// eslint-disable-next-line func-names
addMethod<StringSchema>(string, "validLongitude", function () {
  return this.test("valid longitude", (val : string|undefined) => !val || val!.match(lngRegex) != null);
});
